import React, {useEffect, useMemo, useState} from 'react'
import PageLayout from '../../components/layout/PageLayout'
import Text from '../../components/text/Text'
import Span from '../../components/text/Span'
import useNavigation from '../../hooks/useNavigation'
import WizButton from '../../components/button/WizButton'
import useQueryProCount from '../../hooks/api/user/useQueryProCount'
import useQueryProList from '../../hooks/api/user/useQueryProList'
import {IUserList} from '../../apis/user/getUserList'
import ProListTable from '../../features/page/user/ProListTable'
import WizPagination from '../../components/pagination/WizPagination'

interface IProps {
    className?: string
}

const ProListPage: React.FC<IProps> = ({className}) => {
    const [currentPage, setCurrentPage] = useState(1)
    const {goProHistory} = useNavigation()
    const {data: proData, refetch} = useQueryProList(currentPage)
    const {data: proCount} = useQueryProCount()

    const userList = useMemo(() => {
        let list: IUserList[] = []
        proData?.data?.map(item => list.push(item))
        return list
    }, [proData])

    useEffect(() => {
        refetch()
    }, [currentPage])

    return (
        <PageLayout title={'Pro'} className={className}>
            <div className={'flex items-center justify-between'}>
                <Text className={'mt-[20px] text-[16px]'}>
                    Pro User : <Span className={'text-h3 text-alt_blue'}>{` ${proCount?.data || '-'}`}</Span>
                </Text>
                <WizButton text={'Payment History'} type={'border'} onClick={() => goProHistory()} />
            </div>

            <ProListTable data={userList} className={'mt-[30px]'} />
            <WizPagination
                totalPage={proData?.pageInfo?.total_count}
                currentPage={currentPage}
                onPageChange={item => setCurrentPage(item)}
            />
        </PageLayout>
    )
}

export default ProListPage
